import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styles from './CardCarousel.module.css';
function useAutoRotatingIndex(slideCount, autoPlay, interval) {
    const [activeIndex, setActiveIndex] = useState(0);
    useEffect(() => {
        setActiveIndex(0);
    }, [slideCount]);
    useEffect(() => {
        if (!autoPlay || slideCount <= 1) {
            return undefined;
        }
        const timer = setInterval(() => {
            setActiveIndex(current => (current + 1) % slideCount);
        }, interval);
        return () => clearInterval(timer);
    }, [autoPlay, interval, slideCount]);
    return [activeIndex, setActiveIndex];
}
export const CardCarousel = ({ slides, autoPlay = true, interval = 5000, 'data-testid': dataTestId = 'card-carousel', }) => {
    const [activeIndex, setActiveIndex] = useAutoRotatingIndex(slides.length, autoPlay, interval);
    if (slides.length === 0) {
        return null;
    }
    if (slides.length === 1) {
        return _jsx("div", { "data-testid": dataTestId, children: slides[0].content });
    }
    return (_jsxs("div", { className: styles.wrapper, "data-testid": dataTestId, children: [_jsx("div", { className: styles.slideStack, children: slides.map((slide, index) => {
                    const isActive = index === activeIndex;
                    return (_jsx("div", { className: `${styles.slideItem} ${isActive ? styles.slideItemActive : ''}`, "aria-hidden": !isActive, "data-testid": isActive ? `${dataTestId}-slide` : undefined, children: slide.content }, slide.id));
                }) }), _jsx("div", { className: styles.dots, "data-testid": `${dataTestId}-dots`, children: slides.map((slide, index) => (_jsx("button", { type: 'button', className: `${styles.dot} ${index === activeIndex ? styles.dotActive : ''}`, onClick: () => setActiveIndex(index), "aria-label": `Slide ${index + 1}`, "data-testid": `${dataTestId}-dot-${index}` }, slide.id))) })] }));
};
